<template>
  <component :is="tag" v-on="$listeners">
    <div
      :class="{
        'operator-group': channel.operatorAssigned,
      }"
    >
      <b-avatar
        v-if="channel.operatorAssigned"
        class="merchant-profile"
        size="42"
        :variant="isActive ? 'light-light' : 'light-primary'"
        :src="channel.merchantUserProfile"
        :text="avatarText(channel.merchantUserName)"
      >
        <feather-icon
          v-if="!channel.merchantUserProfile && !channel.merchantUserName"
          icon="UserIcon"
          size="22"
        />
      </b-avatar>
      <b-avatar
        size="42"
        :badge="true"
        class="badge-minimal customer-profile"
        :badge-variant="channel.isOnline ? 'success' : 'secondary'"
        :variant="isActive ? 'light-light' : 'light-primary'"
      >
        <feather-icon icon="UserIcon" size="22" />
      </b-avatar>
    </div>
    <div class="chat-info flex-grow-1">
      <h5 class="mb-0 text-truncate">
        {{ channel.name }}
      </h5>
      <p v-if="channel.latestMessage" class="card-text text-truncate">
        <span v-if="channel.latestMessage.messageType == messageType.text">
          {{
            channel.latestMessage.participantId == userData.id &&
            channel.latestMessage.participantType == 'merchant'
              ? $t('chat.you')
              : channel.latestMessage.name
          }}: {{ channel.latestMessage.message }}
        </span>
        <span v-if="channel.latestMessage.messageType == messageType.image">
          {{
            $t('chat.sendAnAttachment', {
              user:
                channel.latestMessage.participantId == userData.id &&
                channel.latestMessage.participantType == 'merchant'
                  ? $t('chat.you')
                  : channel.latestMessage.name,
            })
          }}
        </span>
        <span v-if="channel.latestMessage.messageType == messageType.status">
          <span v-if="channel.latestMessage.message == 'action.rate'">
            <span v-if="channel.rateData.comment">
              {{
                $t(channel.latestMessage.message, {
                  visitor: channel.name,
                  rate: channel.rateData.rate,
                  comment: channel.rateData.comment,
                })
              }}
            </span>
            <span v-else>
              {{
                $t('action.rateNoComment', {
                  visitor: channel.name,
                  rate: channel.rateData.rate,
                })
              }}
            </span>
          </span>
          <span v-else>
            {{
              $t(channel.latestMessage.message, {
                operator: channel.latestMessage.name,
              })
            }}
          </span>
        </span>
        <span v-if="channel.latestMessage.messageType == messageType.joint">
          {{
            channel.latestMessage.participantId == userData.id &&
            channel.latestMessage.participantType == 'merchant'
              ? `${$t('chat.you')} ${$t('chat.haveJoined')}`
              : `${channel.latestMessage.name} ${$t('chat.joined')}`
          }}
        </span>
      </p>
    </div>
    <div class="chat-meta text-nowrap">
      <small v-if="channel.latestMessage" class="d-block mb-25 chat-time">
        {{ channel.latestMessage.createdAt | formatShortDate }}
      </small>
      <b-badge
        v-if="channel.badgeCount"
        pill
        variant="primary"
        class="float-right"
      >
        {{ channel.badgeCount }}
      </b-badge>
    </div>
  </component>
</template>

<script>
import { BAvatar, BBadge } from 'bootstrap-vue';
import messageType from '@/data/messageType';
import useJwt from '@/auth/jwt/useJwt';

export default {
  components: {
    BAvatar,
    BBadge,
  },
  props: {
    tag: {
      type: String,
      default: 'div',
    },
    channel: {
      type: Object,
      required: true,
    },
    isActive: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      messageType,
    };
  },
  computed: {
    userData() {
      return this.$store.state.profile.email || this.$store.state.profile.phone  
        ? this.$store.state.profile
        : JSON.parse(
            localStorage.getItem(useJwt.jwtConfig.storageUserDataKeyName)
          );
    },
  },
  methods: {
    avatarText(name) {
      if (!name) return '';
      return name.charAt(0).toUpperCase();
    },
  },
};
</script>

<style></style>
